export type BrowserSession = Readonly<{
    version: 2; loginId: string; userId: string;
    accessToken: string; refreshToken: string; email: string;
}>;

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// JWT claims identify a session locally; only the API can authorize it.
export function tokenIdentity(token: string): { userId: string; expires: number } | null {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return null;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        return uuid.test(payload.userId) && Number.isFinite(payload.exp)
            ? { userId: payload.userId, expires: payload.exp * 1000 } : null;
    } catch { return null; }
}

export function parseBrowserSession(raw: string): BrowserSession | null {
    try {
        const value = JSON.parse(raw);
        if (value.version !== 2 || !uuid.test(value.loginId) || typeof value.accessToken !== 'string'
            || typeof value.refreshToken !== 'string' || !value.refreshToken.trim()
            || value.refreshToken.length > 512 || typeof value.email !== 'string') return null;
        const identity = tokenIdentity(value.accessToken);
        if (!identity || identity.userId !== value.userId) return null;
        return { version: 2, loginId: value.loginId, userId: value.userId,
            accessToken: value.accessToken, refreshToken: value.refreshToken, email: value.email };
    } catch { return null; }
}

export function browserCookieName(domain: string) {
    const environment = domain === '.pteultra.com' ? 'prod'
        : domain === '.dev.pteultra.com' ? 'dev' : domain === '.stage.pteultra.com' ? 'stage' : 'local';
    return `pteultra_auth_v2_${environment}`;
}
